import { createAction, props } from '@ngrx/store';
import { Customer } from 'src/app/model/customer';
import { OnlineReservationCategory } from 'src/app/model/login-response.dto';
import { AuditTrail, Reservation, ReservationPurpose, ReservationStatus, TablesSection } from 'src/app/model/reservation';
import { ReservationTag } from 'src/app/model/reservation-tag';
import { Source } from 'src/app/model/source';

export const setReservation = createAction(
  '[Reservation] Set Reservation',
  props<{ reservation: Reservation | null | undefined }>()
);

export const setQuickChangeStatusReservation = createAction(
  '[Reservation] Set Quick Change Status Reservation',
  props<{ reservation: Reservation }>()
);

export const setHideQuickChangeStatus = createAction(
  '[Reservation] Set Hide Quick Change Status'
);

export const loadTablesAvailability = createAction(
  '[Reservation] Load Tables Availability',
  props<{ reservation: Reservation, ignoreUnsetArrivalTimeAndCovers: boolean }>()
);

export const loadTablesAvailabilitySuccess = createAction(
  '[Reservation] Load Tables Availability Success',
  props<{ tableSections: TablesSection[] }>()
);

export const loadTablesAvailabilityFailure = createAction(
  '[Reservation Load Tables Availability Failure',
  props<{ error: any }>()
);

export const loadReservationHistory = createAction(
  '[Reservation] Load Reservation History'
);

export const loadReservationHistorySuccess = createAction(
  '[Reservation] Load Reservation History Success',
  props<{ auditTrails: AuditTrail[] }>()
);

export const loadReservationHistoryFailure = createAction(
  '[Reservation] Load Reservation History Failure',
  props<{ error: any }>()
);

export const submitReservation = createAction(
  '[Reservation] Submit Reservation'
);

export const submitReservationSuccess = createAction(
  '[Reservation] Submit Reservation Success',
  props<{ reservation: Reservation }>()
);

export const submitReservationFailure = createAction(
  '[Reservation] Submit Reservation Failure',
  props<{ error: any }>()
);

export const setReservationStatus = createAction(
  '[Reservation] Set Reservation Status',
  props<{ status: ReservationStatus }>()
);

export const setReservationPurpose = createAction(
  '[Reservation] Set Reservation Purpose',
  props<{ purpose: ReservationPurpose }>()
);

export const setReservationArrivalDate = createAction(
  '[Reservation] Set Reservation Arrival Date',
  props<{ date: Date }>()
);

export const setReservationArrivalTime = createAction(
  '[Reservation] Set Reservation Arrival Time',
  props<{ hour: number, minute: number }>()
);

export const setReservationReturnTime = createAction(
  '[Reservation] Set Reservation Return Time',
  props<{ hour: number, minute: number }>()
);

export const setReservationCovers = createAction(
  '[Reservation] Set Reservation Covers',
  props<{ covers: number }>()
);

export const setReservationAllocatedTables = createAction(
  '[Reservation] Set Reservation Allocated Tables',
  props<{ allocatedTables: string[] }>()
);

export const setReservationTags = createAction(
  '[Reservation] Set Reservation Tags',
  props<{ reservationTags: ReservationTag[] }>()
);

export const setCustomerTags = createAction(
  '[Reservation] Set Customer Tags',
  props<{ customerTags: ReservationTag[] }>()
);

export const setReservationDietaryRestrictions = createAction(
  '[Reservation] Set Reservation Dietary Restrictions',
  props<{ dietaryRestrictions: string }>()
);

export const setCustomerDietaryRestrictions = createAction(
  '[Reservation] Set Customer Dietary Restrictions',
  props<{ dietaryRestrictions: string }>()
);

export const setReservationDiscount = createAction(
  '[Reservation] Set Reservation Discount',
  props<{ discount: string | number }>()
);

export const setReservationBill = createAction(
  '[Reservation] Set Reservation Bill',
  props<{ bill: number }>()
);

export const setReservationExtraInfo = createAction(
  '[Reservation] Set Reservation Extra Info',
  props<{ selectedMenu: string, extraInfo: string }>()
);

export const setReservationSmokingArea = createAction(
  '[Reservation] Set Reservation Smoking Area',
  props<{ value: boolean }>()
);

export const setReservationFixMenu = createAction(
  '[Reservation] Set Reservation Fix Menu',
  props<{ value: boolean }>()
);

export const setReservationHasCake = createAction(
  '[Reservation] Set Reservation Has Cake',
  props<{ value: boolean }>()
);

export const setOnlineCategory = createAction(
  '[Reservation] Set Online Category',
  props<{ onlineCategory: OnlineReservationCategory }>()
);

export const setReservationSource = createAction(
  '[Reservation] Set Reservation Source',
  props<{ source: Source }>()
);

export const setReservationNotes = createAction(
  '[Reservation] Set Reservation Notes',
  props<{ notes: string }>()
);

export const setReservationCustomer = createAction(
  '[Reservation] Set Reservation Customer',
  props<{ customer: Customer }>()
);

export const setReservationCustomerType = createAction(
  '[Reservation] Set Reservation Customer Type',
  props<{ customerType: string }>()
);

export const setReservationCustomerSurname = createAction(
  '[Reservation] Set Reservation Customer Surname',
  props<{ surname: string }>()
);

export const setReservationCustomerName = createAction(
  '[Reservation] Set Reservation Customer Name',
  props<{ name: string }>()
);

export const setReservationCustomerTelephone = createAction(
  '[Reservation] Set Reservation Customer Telephone',
  props<{ telephone: string }>()
);

export const setReservationCustomerMail = createAction(
  '[Reservation] Set Reservation Customer Mail',
  props<{ mail: string }>()
);

export const setArrivalTime = createAction(
  '[Reservation] Set Arrival Time',
  props<{ arrivalTime: { hours: number, mins: number } }>()
);

export const setReadOnlyMode = createAction(
  '[Reservation] Set Read Only Mode',
  props<{ readOnlyMode: boolean }>()
);

export const setReservationTempId = createAction(
  '[Reservation] Set Reservation Temp Id'
);

export const setIsSubmiting = createAction(
  '[Reservation] Set Is Submiting',
  props<{ isSubmiting: boolean }>()
);
export const setReservationRoomNumber = createAction(
  '[Reservation] Set Reservation Room Number',
  props<{ roomNumber: string | null }>()
);
export const setReservationRoomBookingId = createAction(
  '[Reservation] Set Reservation Room Booking ID',
  props<{ roomBookingId: string | null }>()
);
export const setReservationMetadata = createAction(
  '[Reservation] Set Reservation Metadata',
  props<{ metadata: string | null }>()
);
export const changeRestaurant = createAction(
  '[Reservation] Change Restaurant',
  props<{ reservation: Reservation, restaurantId: number }>()
);
export const changeRestaurantSuccess = createAction(
  '[Reservation] Change Restaurant Success'
);
export const changeRestaurantFailure = createAction(
  '[Reservation] Change Restaurant Failure',
  props<{ error: any }>()
);
export const setPaymentLinkExpirationLocal = createAction(
  '[Reservation] Set Payment Link Expiration Local',
  props<{ paymentLinkExpiresAt: string | null }>() // store as YYYY-MM-DD or ISO
);

export const setPaymentLinkExpirationDirty = createAction(
  '[Reservation] Set Payment Link Expiration Dirty',
  props<{ dirty: boolean }>()
);